export var CardBrand;
(function (CardBrand) {
    CardBrand["Visa"] = "VISA";
    CardBrand["Master"] = "MASTERCARD";
    CardBrand["American"] = "AMERICAN_EXPRESS";
    CardBrand["Discover"] = "DISCOVER";
    CardBrand["Diners"] = "DINERS";
    CardBrand["Maestro"] = "MAESTRO";
    CardBrand["UnionPay"] = "UNIONPAY";
    CardBrand["Jcb"] = "JCB";
    CardBrand["CarteBancaire"] = "CARTE_BANCAIRE";
    CardBrand["Dankort"] = "DANKORT";
    CardBrand["Other"] = "OTHER";
})(CardBrand || (CardBrand = {}));
//# sourceMappingURL=card-brand.js.map